import {defer, interval, merge, Subject, combineLatest} from 'rxjs';
import {map, shareReplay, startWith, filter, distinctUntilChanged, switchMapTo} from 'rxjs/operators';
import Big from 'big.js';
import {marginTradeApi} from '@/api/margin-trade';
import {isActivateMarginAccount$} from './config/margin-trade';
import {marginAccounts$} from './margin-trade';
import {isUtaSpot$} from './uta-state';

const fetchData$ = defer(() => {
  const getSysRemainingBorrowFun = createGetSysRemainingBorrowFun(isUtaSpot$.getValue());
  return getSysRemainingBorrowFun();
}).pipe(map((response) => response.data || []));
const refreshNotifier$ = new Subject();

/** 间隔30s自动刷新 */
const autoUpdate$ = interval(30 * 1000).pipe(switchMapTo(fetchData$));
/** 手动借款、自动借款下单出错，手动刷新 */
const customUpdate$ = refreshNotifier$.pipe(switchMapTo(fetchData$));
const remainingBorrowList$ = merge(fetchData$, autoUpdate$, customUpdate$).pipe(shareReplay(1));

/** 查询currency对应的平台剩余可借贷 */
export const sysRemainingBorrowRqAction$ = remainingBorrowList$.pipe(map(sysRemainingBorrowRqAction), startWith(sysRemainingBorrowRqAction([])));

const accountRemainingBorrowRqAction$ = marginAccounts$.pipe(map(accountRemainingBorrowRqAction));
/** 查询currency对应的账户剩余可借贷 */
export const userRemainingBorrowRqAction$ = isActivateMarginAccount$.pipe(
  filter(Boolean),
  distinctUntilChanged(),
  switchMapTo(
    combineLatest([remainingBorrowList$.pipe(map(sysRemainingBorrowRqAction)), accountRemainingBorrowRqAction$]).pipe(
      map(([sysRemainingBorrowRqAction, accountRemainingBorrowRqAction]) => {
        return function (currency) {
          const sysRemainingBorrowRq = sysRemainingBorrowRqAction(currency);
          const accountRemainingBorrowRq = accountRemainingBorrowRqAction(currency);

          return Big(sysRemainingBorrowRq).gt(accountRemainingBorrowRq) ? accountRemainingBorrowRq : sysRemainingBorrowRq;
        };
      })
    )
  ),
  startWith(sysRemainingBorrowRqAction([]))
);

/**
 * 手动刷新平台剩余可借贷
 */
export function refreshSysRemainingBorrowData() {
  refreshNotifier$.next(true);
}

function sysRemainingBorrowRqAction(remainingBorrowList) {
  return function (currency) {
    const currencyInfo = remainingBorrowList.find((item) => item.currency === currency);
    return currencyInfo ? currencyInfo.balanceRq : '0';
  };
}

function accountRemainingBorrowRqAction(accounts) {
  return function (currency) {
    const currencyInfo = accounts.find((account) => account.currency === currency);
    return currencyInfo ? currencyInfo.remainingBorrowEv : '0';
  };
}

function createGetSysRemainingBorrowFun(isUtaSpot) {
  return isUtaSpot ? marginTradeApi.getUtaSysRemainingBorrow : marginTradeApi.getSysRemainingBorrow;
}
